module.exports = __webpack_public_path__ + "img/pillar_of_elmo_fire_small.4232a418.png";